export const musicTagCategories = [
  { id: 'all', label: 'Alle', icon: '🎲' },
  { id: 'country', label: 'Country', icon: '🌍' },
  { id: 'era', label: 'Era', icon: '📅' },
  { id: 'epoch', label: 'Epoche', icon: '🏛️' },
  { id: 'genre', label: 'Genre', icon: '🎼' },
  { id: 'mood', label: 'Mood', icon: '😊' },
  { id: 'theme', label: 'Theme', icon: '🎯' },
  { id: 'format', label: 'Format', icon: '💿' },
  { id: 'form', label: 'Form/Besetzung', icon: '🎻' },
  { id: 'misc', label: 'Misc', icon: '📌' },
  { id: 'artist_composer', label: 'Artist/Komponist', icon: '🎤' }
];

export const musicFavsConfig = {
  apiPath: '/api/music-favs',
  slug: 'musicfavs',
  title: 'music-favs',
  typeLabel: 'Kategorie',
  nameLabel: 'Titel (Werk/Song)',
  artistLabel: 'Artist/Komponist',
  entryTypes: [
    { value: 'e_music', label: 'E-Musik' },
    { value: 'u_music', label: 'U-Musik' }
  ],
  typeFilters: [
    { value: 'both', label: 'both' },
    { value: 'e_music', label: 'E-Musik' },
    { value: 'u_music', label: 'U-Musik' }
  ],
  typeLabels: { e_music: '🎼 E-Musik', u_music: '🎧 U-Musik' },
  exportTypeLabels: { e_music: 'E-Musik', u_music: 'U-Musik' },
  tagCategories: musicTagCategories,
  searchPlaceholder: 'Titel, Artist/Komponist oder Beschreibung...'
};
